/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Aggregation } from './Aggregation';
import {
    AggregationFromJSON,
    AggregationFromJSONTyped,
    AggregationToJSON,
    AggregationToJSONTyped,
} from './Aggregation';
import type { DataRequestResource } from './DataRequestResource';
import {
    DataRequestResourceFromJSON,
    DataRequestResourceFromJSONTyped,
    DataRequestResourceToJSON,
    DataRequestResourceToJSONTyped,
} from './DataRequestResource';

/**
 * 
 * @export
 * @interface ScatterDataRequest
 */
export interface ScatterDataRequest {
    /**
     * 
     * @type {Array<DataRequestResource>}
     * @memberof ScatterDataRequest
     */
    resources: Array<DataRequestResource>;
    /**
     * 
     * @type {string}
     * @memberof ScatterDataRequest
     */
    xAxisMetricKey: string;
    /**
     * 
     * @type {Aggregation}
     * @memberof ScatterDataRequest
     */
    xAxisAggregation: Aggregation;
}



/**
 * Check if a given object implements the ScatterDataRequest interface.
 */
export function instanceOfScatterDataRequest(value: object): value is ScatterDataRequest {
    if (!('resources' in value) || value['resources'] === undefined) return false;
    if (!('xAxisMetricKey' in value) || value['xAxisMetricKey'] === undefined) return false;
    if (!('xAxisAggregation' in value) || value['xAxisAggregation'] === undefined) return false;
    return true;
}

export function ScatterDataRequestFromJSON(json: any): ScatterDataRequest {
    return ScatterDataRequestFromJSONTyped(json, false);
}

export function ScatterDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScatterDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resources': ((json['resources'] as Array<any>).map(DataRequestResourceFromJSON)),
        'xAxisMetricKey': json['xAxisMetricKey'],
        'xAxisAggregation': AggregationFromJSON(json['xAxisAggregation']),
    };
}

export function ScatterDataRequestToJSON(json: any): ScatterDataRequest {
    return ScatterDataRequestToJSONTyped(json, false);
}

export function ScatterDataRequestToJSONTyped(value?: ScatterDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resources': ((value['resources'] as Array<any>).map(DataRequestResourceToJSON)),
        'xAxisMetricKey': value['xAxisMetricKey'],
        'xAxisAggregation': AggregationToJSON(value['xAxisAggregation']),
    };
}

